import { I18n } from '@calendly/i18n'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { redirectToAuthorizeUrl } from 'actions/omniauth'
import { PageContent } from 'components/page_elements'
import { useBooleanState } from 'hooks/useBooleanState'

import CalendlyLogo from './calendly-logo'
import {
  Container,
  LogoContainer,
  ConnectLogo,
  PlusIcon,
  ConnectButton
} from './elements'
import IntercomLogo from './intercom-logo'

export const Intercom = () => {
  const dispatch = useDispatch()
  const [isConnecting, startConnect] = useBooleanState(false)

  const connect = useCallback(
    () => {
      startConnect()
      dispatch(redirectToAuthorizeUrl('/users/auth/intercom_oauth2'))
    },
    [startConnect, dispatch]
  )

  return (
    <PageContent>
      <Container>
        <LogoContainer>
          <ConnectLogo src={CalendlyLogo} />
          <PlusIcon />
          <ConnectLogo src={IntercomLogo} />
        </LogoContainer>
        <ConnectButton
          onClick={connect}
          loading={isConnecting}
        >
          {I18n.t('publisher.integrations.intercom.action_connect')}
        </ConnectButton>
      </Container>
    </PageContent>
  )
}
